module.exports = __webpack_public_path__ + "static/media/inelcas_meter.58367127.png";